import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import FormattedCurrency from '../../../../components/formatted-currency/container';

// Constants functions a pseduo-error codes
const ADD_FUNDING_ERROR = 'Invalid purchase amount.';
const NEGATIVE_NUM_ERROR = "'Value' must be greater than or equal to '0'";

const messages = defineMessages({
  minMaxFundingError: {
    description: 'Add funds minimum funding error',
    defaultMessage: 'Minimum funding amount is {min}, the maximum funding amount is {max}.',
    id: 'el5RZk',
  },
  amountCannotBeNegative: {
    description: 'Auto fund amount cant be less than 0',
    defaultMessage: 'Value must be greater than 0.',
    id: 'b2+9Zq',
  },
  unknownErrorWithoutMessage: {
    description: 'Unknown error without message from server',
    defaultMessage: 'An unknown error occurred.',
    id: 'CId2Ig',
  },
});

const getUIErrorMessage = (errorResponse, currencyCode) => {
  if (!errorResponse?.Message) {
    return messages.unknownErrorWithoutMessage;
  }

  if (errorResponse.Message.startsWith(ADD_FUNDING_ERROR)) {
    return {
      ...messages.minMaxFundingError,
      values: {
        min: <FormattedCurrency currencyCode={currencyCode} value={10} />,
        max: <FormattedCurrency currencyCode={currencyCode} value={10000} />,
      },
    };
  }

  if (errorResponse.Message.startsWith(NEGATIVE_NUM_ERROR)) {
    return {
      ...messages.amountCannotBeNegative,
    };
  }

  return errorResponse.Message;
};

const AddFundErrorMessage = ({ error, currencyCode }) => {
  const messageDescriptor = getUIErrorMessage(error, currencyCode);

  return (
    <>
      <li>{typeof messageDescriptor === 'string' ? messageDescriptor : <FormattedMessage {...messageDescriptor} />}</li>
    </>
  );
};

AddFundErrorMessage.propTypes = {
  error: PropTypes.object.isRequired,
  currencyCode: PropTypes.string.isRequired,
};

export default AddFundErrorMessage;
